import sortBy from 'lodash/sortBy'
import partition from 'lodash/partition'
import { Workspace } from '@chilipiper/api-type-def'
import { ApiBookingLink } from '../../types'
import {
  AddDefaultBookingLink,
  GroupedBookingLinks,
  GroupedByWorkspaceName,
  SplitFavouritesBookingLink,
  SortLinksByFavouriteOrder,
  ToogleFavouriteTemplate,
} from './types'

export const moveDefaultToFront = (bookingLinks: ApiBookingLink[]) => {
  return bookingLinks.reduce((acc, bookingLink) => {
    if (bookingLink?.isDefault) {
      return [bookingLink, ...acc]
    }

    return [...acc, bookingLink]
  }, [] as ApiBookingLink[])
}

export const movePersonalToFront = (bookingLinks: ApiBookingLink[]) => {
  return bookingLinks.reduce((acc, bookingLink) => {
    if (bookingLink?.isPersonal || !bookingLink?.workspaceId) {
      return [bookingLink, ...acc]
    }

    return [...acc, bookingLink]
  }, [] as ApiBookingLink[])
}

export const searchLinks = (search: string, bookingLinks: ApiBookingLink[]) => {
  return bookingLinks.filter(bookingLink =>
    bookingLink.name.toLowerCase().includes(search.toLowerCase())
  )
}

export const addDefaultBookingLink = ({
  bookingLinks,
  defaultBookingLinkUrl,
}: AddDefaultBookingLink) => {
  return bookingLinks.map(bookingLink => {
    if (bookingLink?.isDefault) {
      return { ...bookingLink, link: defaultBookingLinkUrl || bookingLink.link, isPersonal: true }
    }

    return bookingLink
  })
}

export const groupByWorkspaceName = ({
  workspaces = [],
  groupedBookingLinks = {},
}: GroupedByWorkspaceName) => {
  const groupedByWorkspaceName: GroupedBookingLinks = {}

  Object.keys(groupedBookingLinks).forEach(workspaceId => {
    const workspace = workspaces?.find((workspace: Workspace) => workspace.id === workspaceId)
    const workspaceName = workspaceId === 'Personal' ? 'Personal Workspace' : workspace?.name
    groupedByWorkspaceName[workspaceName || 'Unknown Workspace'] = groupedBookingLinks[workspaceId]
  })

  return groupedByWorkspaceName
}

export const orderLinksByLatestCreated = (bookingLinks: ApiBookingLink[]) => {
  return bookingLinks?.sort(
    ({ createdAt: createdAtA = 0 }, { createdAt: createdAtB = 0 }) =>
      Number(createdAtB) - Number(createdAtA)
  )
}

export const isOverflowing = (el: HTMLElement) => el?.clientHeight < el?.scrollHeight

export const sortLinksByFavouriteOrder = ({
  bookingLinks = [],
  favouriteTemplates = [],
}: SortLinksByFavouriteOrder) => {
  return sortBy(bookingLinks, bookingLink => {
    const index = favouriteTemplates?.findIndex(
      templateId => bookingLink?.templateId === templateId
    )
    return index != -1 ? index : bookingLinks.length
  })
}

export const splitFavourites = ({
  bookingLinks = [],
  favouriteTemplates = [],
}: SplitFavouritesBookingLink) => {
  return partition(bookingLinks, bookingLink =>
    favouriteTemplates?.includes(bookingLink?.templateId)
  )
}

export const toogleFavouriteTemplate = ({
  templateId = '',
  userSettings,
}: ToogleFavouriteTemplate) => {
  const currentFavourites = userSettings?.favouriteTemplates ?? []
  const isFavourite = currentFavourites?.includes(templateId)
  const favouriteTemplates = isFavourite
    ? currentFavourites.filter(id => id !== templateId)
    : [...currentFavourites, ...(templateId ? [templateId] : [])]
  return { ...(userSettings ?? {}), favouriteTemplates }
}
